<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H43HNz/tc-custom/9781398448179.jpg?1682168954092" alt="This image is the cover for the book Squiggly Diddly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Squiggly Diddly
      </h1>
      <p class="bookDescription body article font2">
        <p>Squiggly Diddly Spider is sitting happily in her web in the kitchen when suddenly she spots a juicy fly that she can enjoy for her tea; all she needs to do is catch him first! Squiggly is feeling very hungry, so she scrambles down to the floor where Mummy sees her, and Mummy doesn’t look very happy! Out comes the big sweeping brush, alongside Dad with his stomping shoe! Will Squiggly Diddly get splatted by Mummy or Dad? Or will she escape? Will Squiggly ever catch the yummy-looking fly and get to eat him for her tea? Or does the fly have another idea to save him so he doesn’t end up being on Squiggly Diddly’s plate?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.D. Anderson
      </h2>
      
      <p class="authorDescription body article">Stockport-based NHS Support Services Manager Jenna is a published poet, writer and author. With over a decade of creating characters and bedtime stories for her two children, her girls’ favourite tale has now been brought to life in the form of her new children’s story Squiggly Diddly. Jenna has been a lifelong writer and first began penning her characters’ adventures whilst still at school.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f40ccea